import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import axios from "axios";
import { BASE_URL } from "../api";
import { getApiHeaders } from "../utils/helpers";
import { setManualLogout } from "../token";
import MessageToster from "./MessageToster";
import { useUser } from "../context/UserContext";

export default function Sidebar() {
  const navigate = useNavigate();
  const userContext = useUser();
  const cookieUserData = JSON.parse(Cookies.get("userdata") || "{}");
  const userData = userContext?.userData || cookieUserData;
  const rawIbStatus = String(userData?.ibStatus || "").toLowerCase().trim();
  const isIbUser = Number(userData?.isIb) === 1 || ["active", "approve", "approved"].includes(rawIbStatus);
  const isIbPending = rawIbStatus === "pending";
  const isIbRejected = ["reject", "rejected"].includes(rawIbStatus);
  const [activeMenu, setActiveMenu] = useState(null);

  useEffect(() => {
    const closeBtn = document.getElementById("close-menu-btn");

    const handleClick = () => {
      document.body.classList.remove("sidebar-enable");
    };

    if (closeBtn) {
      closeBtn.addEventListener("click", handleClick);
    }

    // Clean up the event listener when component unmounts
    return () => {
      if (closeBtn) {
        closeBtn.removeEventListener("click", handleClick);
      }
    };
  }, []);
  const { pathname } = useLocation();

  const isActive = (path) => pathname === path;

  const location = useLocation();
  // const [activeMenu, setActiveMenu] = useState("");

  const menuMappings = {
    trade: [
      "/terminal",
      "/watchlist",
      "/position",
      "/pending-order",
      "/order-history",
    ],
    accounts: [
      "/demo_account",
      "/live_account",
      "/leverage_history",
      "/trade_history",
      "/transfer",
      "/live_trades",
      "/account_transaction",
      "/user_transfer_history",
    ],
    ibAccounts: [
      "/become-ib",
      "/ib_dashboard",
      "/overview",
      "/withdrawal",
      "/report",
      "/ib_commission_report",
      "/ib-income",
      "/cpa-history",
      "/cpa_history",
      "/ib-pending-list",
      "/ib_pending_list",
    ],
    payments: [
      "/transaction",
      "/bank-details",
      "/bank_details",
      "/add_bank_details",
    ],
    support: [
      "/tickets",
      "/faq",
    ],
    setting: [
      "/profile",
      "/security",
      "/notification",
      "/notifications",
    ],
    income: [
      "/direct-income",
      "/profit-income",
    ],
    learnAndEarn: [
      "/bonus-programs",
      "/bonus-program",
      "/bonus-history",
      "/bonus_history",
      "/claim-history",
      "/claim_history",
      "/learn-and-earn",
      "/learn_and_earn",
      "/trade-and-earn",
      "/trade_and_earn",
    ],
    copyTrading: [
      "/copy-trading",
      "/copy-trading/leaderboard",
      "/copy-trading/master-traders",
      "/copy-trading/subscribe",
      "/copy-trading/my-copiers",
      "/copy-trading/my-masters",
    ],
    pammTrading: [
      "/pamm-leaderboard",
      "/pamm-subscribed",
      "/pamm-published",
    ],
  };

  // Auto open menu if current route matches
  useEffect(() => {
    const currentPath = location.pathname;

    for (const menu in menuMappings) {
      if (menuMappings[menu].includes(currentPath)) {
        setActiveMenu(menu);
        break;
      }
    }
  }, [location.pathname]);

  const toggleMenu = (menuName) => {
    setActiveMenu((prev) => (prev === menuName ? "" : menuName));
  };

  const currentPath = location.pathname;

  const handleLogout = async () => {
    setManualLogout(true);

    const devicetoken =
      localStorage.getItem("devicetoken") ||
      sessionStorage.getItem("devicetoken") ||
      "";

    const payload = {
      logout_all_devices: false,
      devicetoken: devicetoken,
    };

    try {
      await axios.post(
        `${BASE_URL}/account/logout`,
        payload,
        { headers: getApiHeaders() }
      );
    } catch (err) {
      console.error("Logout API error:", err);
    } finally {
      Cookies.remove("userdata");
      Cookies.remove("token");
      Cookies.remove("username");
      sessionStorage.removeItem("mid");
      sessionStorage.removeItem("email");
      sessionStorage.removeItem("devicetoken");
      localStorage.removeItem("devicetoken");
      MessageToster("success", "You have been logged out successfully.");
      setTimeout(() => navigate("/", { replace: true }), 800);
    }
  };

  return (
    <>
      <div className="vertical-menu">
        <div data-simplebar="" className="h-100">
          {/*- Sidemenu */}
          <div
            id="sidebar-menu"
            className="transi"
            onClick={(e) => {
              const link = e.target.closest('a');
              if (link && !link.classList.contains('has-arrow')) {
                document.body.classList.remove("sidebar-enable");
              }
            }}
          >
            <div className="d-flex">
              {/* LOGO */}
              <div className="navbar-brand-box">
                <a href="/dashboard" className="logo logo-dark">
                  <span className="logo-sm">
                    <img src="/assets/images/logo.svg" alt="" height={22} />
                  </span>
                  <span className="logo-lg">
                    <img src="/assets/images/logo-dark.png" alt="" height={17} />
                  </span>
                </a>
                <a href="/dashboard" className="logo logo-light">
                  <span className="logo-sm">
                    <img
                      src="/assets/images/logo-light.svg"
                      alt=""
                      height={22}
                    />
                  </span>
                  <span className="logo-lg">
                    <img
                      src="/assets/images/logo-light.png"
                      alt=""
                      height={19}
                    />
                  </span>
                </a>
              </div>
              <button
                type="button"
                className="btn btn-sm px-3 font-size-16 header-item waves-effect"
                id="close-menu-btn"
              >
                <i className="bx bx-x-circle" />
              </button>
            </div>
            {/* Left Menu Start */}
            <ul className="metismenu list-unstyled" id="side-menu">
              <li>
                <Link to="/dashboard" className={`waves-effect ${isActive("/dashboard") ? "active-link" : ""}`}>
                  <i className="bx bx-home-circle" />
                  <span>Dashboards</span>
                </Link>
              </li>
              <li>
                <Link to="/wallet" className={`waves-effect ${isActive("/wallet") ? "active-link" : ""}`}>
                  <i className="bx bx-wallet-alt" />
                  <span>My Wallet</span>
                </Link>
              </li>
              <li>
                <Link to="/kyc_documents" className={`waves-effect ${isActive("/kyc_documents") ? "active-link" : ""}`}>
                  <i className="bx bx-file-find" />
                  <span>Kyc Documents</span>
                </Link>
              </li>
              <li>
                <Link to="/deposit" className={`waves-effect ${isActive("/deposit") || currentPath === "/deposit" ? "active-link" : ""}`}>
                  <i className="bx bx-down-arrow-circle" />
                  <span>Deposit</span>
                </Link>
              </li>
              <li className={activeMenu === "accounts" ? "menu-item open mm-active" : "menu-item"}>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleMenu("accounts");
                  }}
                  className="has-arrow waves-effect"
                >
                  <i className="bx bx-user-plus" />
                  <span>MT5 Account</span>
                </a>

                <ul
                  className={`sub-menu ${activeMenu === "accounts" ? "show" : ""}`}
                  aria-expanded={activeMenu === "accounts"}
                >
                  <li className={currentPath === "/demo_account" ? "active-link" : ""}>
                    <Link to="/demo_account">Demo Accounts</Link>
                  </li>
                  <li className={currentPath === "/live_account" ? "active-link" : ""}>
                    <Link to="/live_account">Live Accounts</Link>
                  </li>
                  <li className={currentPath === "/transfer" ? "active-link" : ""}>
                    <Link to="/transfer">Transfer</Link>
                  </li>
                  <li
                    className={
                      currentPath === "/account_transaction" ||
                        currentPath === "/user_transfer_history"
                        ? "active-link"
                        : ""
                    }
                  >
                    <Link to="/account_transaction">
                      {currentPath === "/user_transfer_history"
                        ? "User Transfer History"
                        : "Transfer History"}
                    </Link>
                  </li>
                  <li className={currentPath === "/trade_history" ? "active-link" : ""}>
                    <Link to="/trade_history">Trade History</Link>
                  </li>
                  <li className={currentPath === "/live_trades" ? "active-link" : ""}>
                    <Link to="/live_trades">Live Trades</Link>
                  </li>
                  <li className={currentPath === "/leverage_history" ? "active-link" : ""}>
                    <Link to="/leverage_history">Leverage History</Link>
                  </li>
                </ul>
              </li>
              {/* <li className={activeMenu === "trade" ? "menu-item open mm-active" : "menu-item"}>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleMenu("trade");
                  }}
                  className="has-arrow waves-effect"
                >
                  <i className="bx bx-trending-up" />
                  <span>Trade</span>
                </a>

                <ul
                  className={`sub-menu ${activeMenu === "trade" ? "show" : ""}`}
                  aria-expanded={activeMenu === "trade"}
                >
                  <li className={currentPath === "/terminal" ? "active-link" : ""}>
                    <Link to="/terminal">Terminal</Link>
                  </li>
                  <li className={currentPath === "/watchlist" ? "active-link" : ""}>
                    <Link to="/watchlist">Watchlist</Link>
                  </li>
                  <li className={currentPath === "/position" ? "active-link" : ""}>
                    <Link to="/position">Position</Link>
                  </li>
                  <li className={currentPath === "/pending-order" ? "active-link" : ""}>
                    <Link to="/pending-order">Pending Order</Link>
                  </li>
                  <li className={currentPath === "/order-history" ? "active-link" : ""}>
                    <Link to="/order-history">Order History</Link>
                  </li>
                </ul>
              </li> */}
              <li>
                <Link to="/withdraw" className={`waves-effect ${isActive("/withdraw") || currentPath === "/withdraw" || currentPath === "/crypto_withdraw" ? "active-link" : ""}`}>
                  <i className="bx bx-up-arrow-circle" />
                  <span>Withdraw</span>
                </Link>
              </li>
              {/* Payments dropdown menu (commented out) */}
              {/* <li className={activeMenu === "payments" ? "menu-item open mm-active" : "menu-item"}>
                <a href="#" onClick={(e) => { e.preventDefault(); toggleMenu("payments"); }} className="has-arrow waves-effect">
                  <i className="bx bx-credit-card" />
                  <span>Payments</span>
                </a>
                <ul className={`sub-menu ${activeMenu === "payments" ? "show" : ""}`}>
                  <li className={currentPath === "/transaction" ? "active-link" : ""}>
                    <Link to="/transaction">Account Transaction</Link>
                  </li>
                  <li className={currentPath === "/bank-details" || currentPath === "/bank_details" || currentPath === "/add_bank_details" ? "active-link" : ""}>
                    <Link to="/bank-details">Bank Details</Link>
                  </li>
                </ul>
              </li> */}
              <li>
                <Link
                  to="/bank-details"
                  className={`waves-effect ${isActive("/bank-details") || currentPath === "/bank-details" || currentPath === "/bank_details" || currentPath === "/add_bank_details" ? "active-link" : ""}`}
                >
                  <i className="bx bxs-bank" />
                  <span>Bank Details</span>
                </Link>
              </li>
              {/* <li className={activeMenu === "income" ? "menu-item open mm-active" : "menu-item"}>
                <a href="#" onClick={(e) => { e.preventDefault(); toggleMenu("income"); }} className="has-arrow waves-effect">
                  <i className="bx bx-money" />
                  <span>Income</span>
                </a>
                <ul className={`sub-menu ${activeMenu === "income" ? "show" : ""}`}>
                  <li className={currentPath === "/direct-income" ? "active-link" : ""}>
                    <Link to="/direct-income">Direct Income</Link>
                  </li>
                  <li className={currentPath === "/profit-income" ? "active-link" : ""}>
                    <Link to="/profit-income">Profit Income</Link>
                  </li>
                </ul>
              </li> */}
              <li className={activeMenu === "ibAccounts" ? "menu-item open mm-active" : "menu-item"}>
                <a href="#" onClick={(e) => { e.preventDefault(); toggleMenu("ibAccounts"); }} className="has-arrow waves-effect">
                  <i className="bx bx-group" />
                  <span>IB Accounts</span>
                </a>
                <ul className={`sub-menu ${activeMenu === "ibAccounts" ? "show" : ""}`}>
                  {!isIbUser ? (
                    <li className={currentPath === "/become-ib" ? "active-link" : ""}>
                      <Link to="/become-ib">
                        Become An IB
                        {isIbPending && (
                          <span className="badge bg-warning-subtle text-warning font-size-10 px-1 py-0 ms-1">
                            Pending
                          </span>
                        )}
                        {isIbRejected && (
                          <span className="badge bg-danger-subtle text-danger font-size-10 px-1 py-0 ms-1">
                            Rejected
                          </span>
                        )}
                      </Link>
                    </li>
                  ) : (
                    <>
                      <li className={currentPath === "/ib_dashboard" ? "active-link" : ""}>
                        <Link to="/ib_dashboard">IB Dashboard</Link>
                      </li>
                      <li className={currentPath === "/overview" ? "active-link" : ""}>
                        <Link to="/overview">IB Overview</Link>
                      </li>
                      {/* <li className={currentPath === "/withdrawal" ? "active-link" : ""}>
                        <Link to="/withdrawal">IB Withdrawal</Link>
                      </li> */}
                      {/* <li className={currentPath === "/report" ? "active-link" : ""}>
                        <Link to="/report">IB Reports</Link>
                      </li> */}
                      {/* <li className={currentPath === "/ib_commission_report" ? "active-link" : ""}>
                        <Link to="/ib_commission_report">IB Commission Report</Link>
                      </li> */}
                      <li className={currentPath === "/ib-income" ? "active-link" : ""}>
                        <Link to="/ib-income">IB Income</Link>
                      </li>
                      <li className={currentPath === "/cpa-history" || currentPath === "/cpa_history" ? "active-link" : ""}>
                        <Link to="/cpa-history">IB CPA History</Link>
                      </li>
                      <li className={currentPath === "/ib-pending-list" || currentPath === "/ib_pending_list" ? "active-link" : ""}>
                        <Link to="/ib-pending-list">IB Pending List</Link>
                      </li>
                    </>
                  )}
                </ul>
              </li>
              <li className={activeMenu === "learnAndEarn" ? "menu-item open mm-active" : "menu-item"}>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleMenu("learnAndEarn");
                  }}
                  className="has-arrow waves-effect"
                >
                  <i className="bx bxs-institution" />
                  <span>Learn &amp; Earn</span>
                </a>
                <ul className={`sub-menu ${activeMenu === "learnAndEarn" ? "show" : ""}`}>
                  <li className={currentPath === "/bonus-programs" || currentPath === "/bonus-program" || currentPath === "/bonus-history" || currentPath === "/bonus_history" || currentPath === "/claim-history" || currentPath === "/claim_history" ? "active-link" : ""}>
                    <Link to="/bonus-programs">Bonus Programs</Link>
                  </li>
                  <li className={currentPath === "/learn-and-earn" || currentPath === "/learn_and_earn" || currentPath === "/point-details" ? "active-link" : ""}>
                    <Link to="/learn-and-earn">Learn &amp; Earn</Link>
                  </li>
                  <li className={currentPath === "/trade-and-earn" || currentPath === "/trade_and_earn" ? "active-link" : ""}>
                    <Link to="/trade-and-earn">Trade &amp; Earn</Link>
                  </li>
                </ul>
              </li>
              {/* Copy Trading Menu Item (Commented Out) */}
              {/* <li className={activeMenu === "copyTrading" ? "menu-item open mm-active" : "menu-item"}>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleMenu("copyTrading");
                  }}
                  className="has-arrow waves-effect"
                >
                  <i className="bx bx-copy" />
                  <span>Copy Trading</span>
                </a>
                <ul className={`sub-menu ${activeMenu === "copyTrading" ? "show" : ""}`}>
                  <li className={currentPath === "/copy-trading" || currentPath === "/copy-trading/leaderboard" ? "active-link" : ""}>
                    <Link to="/copy-trading/leaderboard">Leaderboard</Link>
                  </li>
                  <li className={currentPath === "/copy-trading/master-traders" ? "active-link" : ""}>
                    <Link to="/copy-trading/master-traders">All Master Traders</Link>
                  </li>
                  <li className={currentPath === "/copy-trading/subscribe" ? "active-link" : ""}>
                    <Link to="/copy-trading/subscribe">Subscribe</Link>
                  </li>
                  <li className={currentPath === "/copy-trading/my-copiers" ? "active-link" : ""}>
                    <Link to="/copy-trading/my-copiers">My Copiers</Link>
                  </li>
                  <li className={currentPath === "/copy-trading/my-masters" ? "active-link" : ""}>
                    <Link to="/copy-trading/my-masters">My Master Traders</Link>
                  </li>
                </ul>
              </li> */}

              {/* <li className={activeMenu === "pammTrading" ? "menu-item open mm-active" : "menu-item"}>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleMenu("pammTrading");
                  }}
                  className="has-arrow waves-effect"
                >
                  <i className="bx bx-bar-chart-alt-2" />
                  <span>PAMM Trading</span>
                </a>
                <ul className={`sub-menu ${activeMenu === "pammTrading" ? "show" : ""}`}>
                  <li className={currentPath === "/pamm-leaderboard" ? "active-link" : ""}>
                    <Link to="/pamm-leaderboard">Leaderboard</Link>
                  </li>
                  <li className={currentPath === "/pamm-subscribed" ? "active-link" : ""}>
                    <Link to="/pamm-subscribed">Subscribed</Link>
                  </li>
                  <li className={currentPath === "/pamm-published" ? "active-link" : ""}>
                    <Link to="/pamm-published">Published</Link>
                  </li>
                </ul>
              </li> */}

              <li className={activeMenu === "support" ? "menu-item open mm-active" : "menu-item"}>
                <a href="#" onClick={(e) => { e.preventDefault(); toggleMenu("support"); }} className="has-arrow waves-effect">
                  <i className="bx bx-support" />
                  <span>Support</span>
                </a>
                <ul className={`sub-menu ${activeMenu === "support" ? "show" : ""}`}>
                  <li className={currentPath === "/tickets" ? "active-link" : ""}>
                    <Link to="/tickets">Tickets</Link>
                  </li>
                  {/* <li className={currentPath === "/faq" ? "active-link" : ""}>
                    <Link to="/faq">Faq</Link>
                  </li> */}
                </ul>
              </li>
              <li className={activeMenu === "setting" ? "menu-item open mm-active" : "menu-item"}>
                <a href="#" onClick={(e) => { e.preventDefault(); toggleMenu("setting"); }} className="has-arrow waves-effect">
                  <i className="bx bx-cog" />
                  <span>Setting</span>
                </a>
                <ul className={`sub-menu ${activeMenu === "setting" ? "show" : ""}`}>
                  <li className={currentPath === "/profile" ? "active-link" : ""}>
                    <Link to="/profile">Profile</Link>
                  </li>
                  <li className={currentPath === "/security" ? "active-link" : ""}>
                    <Link to="/security">Security</Link>
                  </li>
                  <li className={currentPath === "/notification" || currentPath === "/notifications" ? "active-link" : ""}>
                    <Link to="/notification">Notification</Link>
                  </li>
                </ul>
              </li>
              {/* <li>
                <Link
                  to="/analytics"
                  className={`waves-effect ${isActive("/analytics") ? "active-link" : ""}`}
                >
                  <i className="bx bx-link" />
                  <span>Analytics</span>
                </Link>
              </li> */}
              <li>
                <Link to="/news" className={`waves-effect ${isActive("/news") ? "active-link" : ""}`}>
                  <i className="bx bx-news" />
                  <span>News</span>
                </Link>
              </li>
              {/* <li>
                <Link
                  to="/quick-links"
                  className={`waves-effect ${isActive("/quick-links") ? "active-link" : ""}`}
                >
                  <i className="bx bx-link" />
                  <span>Quick Links</span>
                </Link>
              </li> */}
            </ul>
          </div >
        </div >

        {/* Fixed Bottom Rectangle Logout Button (Commented for now) */}
        {/* <div className="sidebar-bottom-logout">
          <button
            type="button"
            onClick={handleLogout}
            className="sidebar-logout-btn"
            title="Logout"
          >
            <i className="bx bx-power-off" style={{ fontSize: "14px" }} />
            <span className="logout-text">Logout</span>
          </button>
        </div> */}
      </div >
    </>
  );
}
